module.exports = "body {\r\n  background-color: #f8f8f8;\r\n}\r\n\r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main